import { useState } from 'react';

export const usePaymentCard = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values, onPaymentCard) => {
    setLoading(true);
    setError(null);
    try {
      await onPaymentCard(values);
    } catch (err) {
      setError('Invalid payment card. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    handleSubmit,
  };
};
